<script>
import tagForm from "@/views/menu/taxonomy/tag/tagForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    tagService: "tagService",
    toastService: "toastService",
  },
})
export default class TagNew extends mixins(tagForm) {
  formId = "new-tag-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save,
      },
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
      await this.tagService.create(this.model);
      this.$router.push(`/taxonomy/${this.model.idTaxonomy}/tag/list`);
      this.toastService.success(this.translations.success.tag_create);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.tags_new;
  }

  afterCreate () {
    this.model = {
      idTaxonomy: this.idTaxonomy,
      code: null,
      localizations: [],
    };
    this.isReady = true;
  }
}
</script>
